import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sf-logout-layout',
  templateUrl: './logout-layout.component.html',
  styleUrls: ['./logout-layout.component.scss']
})
export class LogoutLayoutComponent {}
